export default class BlockVideoHero {
    constructor(container, options) {
        const defaultOptions = {
            plyr: '.video-plyr',
            moduleContainer: '.video-container',
            moduleWrapper: '.video-wrapper',
            loaderEnabled: false,
            loaderContainer: '.loading-container'
        };
        this.options = Object.assign({}, defaultOptions, options);
        
        this.screenWidth = window.innerWidth;
        this.videoPaused = true;

        this.container = document.querySelector(container);
        if(this.container) {
            this.plyr = this.container.querySelector(this.options.plyr);
            this.moduleContainer = this.container.querySelector(this.options.moduleContainer);
            this.moduleWrapper = this.container.querySelector(this.options.moduleWrapper);
            this.loaderContainer = this.container.querySelector(this.options.loaderContainer);
            
            this.init();
            this.setEvents();
        }
        
    }

    setEvents() {
        this.container.addEventListener('click', () => {
            this.videoPaused = !this.videoPaused;
            if (this.videoPaused) {
                this.plyr.style.opacity = '1';
                this.videoPlayer.pause();
            }
        });
    }
    
    init() {
        this.videoPlayer = new Plyr(this.plyr, {
            controls: [
                'play-large',
                'play',
                'progress',
                'mute',
                'fullscreen',
                'volume'
            ],
            debug: false,
            volume: 0,
            autoplay: false,
            muted: true
        });
        
        this.play();
    }
    
    play() {
        if (this.screenWidth >= 768) {
            this.videoPlayer.on('ready', () => {
                this.videoPlayer.play();
            })
            
            this.videoPlayer.on('playing', () => {
                this.moduleWrapper.classList.add('active');
                this.loaderContainer.classList.remove('active');
            });
        } else {
            this.moduleWrapper.classList.add('active');
            this.loaderContainer.classList.remove('active');
            // setTimeout(() => {
            //     this.moduleWrapper.classList.add('active');
            // }, 1500);
        }
    }
}